import { Button } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import axiosInstance from "utils/axiosInstance";
import DashboardCard from "./DashboardCard";

const Dashboard = () => {
  const { data } = useQuery({
    queryKey: ["DASHBOARD_CARD_DATA"],
    queryFn: () => axiosInstance.get("/super_admin/counts/"),
  });

  return (
    <DashboardLayout
      title="Dashboard"
      breadcrumbs={[
        {
          name: "Dashboard",
          path: "/app/dashboard",
        },
      ]}
      toolbar={<Button variant="outlined">Users</Button>}
    >
      <DashboardCard data={data?.data} />
    </DashboardLayout>
  );
};

export default Dashboard;
